// Add multiple kids descriptions for different images
export const kidsdescriptions = Array.from({ length: 1000 }, () => `Kids Series`);

const kidscontext = Array(1000).fill("Kids wallpapers bring fun and imagination to interiors, turning ordinary walls into playful spaces full of color and creativity. They create an environment that reflects joy, curiosity, and a lively sense of wonder, making every room feel cheerful and inspiring for children.");

// Base AWS S3 URL
const AWS_BASE_URL = "https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Kids";

// Function to get image URL with fallback between .jpeg and .jpg
const getImageUrl = (imageNumber) => {
    const jpegUrl = `${AWS_BASE_URL}/kids-${imageNumber}.jpeg`;
    const jpgUrl = `${AWS_BASE_URL}/kids-${imageNumber}.jpg`;

    // Return an object with both URLs for the component to handle
    return {
        jpeg: jpegUrl,
        jpg: jpgUrl
    };
};

// Seeded random generator (Mulberry32)
function mulberry32(seed) {
    return function () {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Deterministic shuffle using seed
function seededShuffle(array, seed = 123456) {
    const rng = mulberry32(seed);
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Generate wall data
const generateWalldata = () =>
    Array.from({ length: 112 }, (_, index) => {
        const imgNum = index + 1;
        const imageUrls = getImageUrl(imgNum);

        return {
            Img: imageUrls.jpeg, // Default to jpeg, component will handle fallback
            ImgJpg: imageUrls.jpg, // Backup jpg URL
            title: `#KD${String(imgNum).padStart(3, '0')}`,
            desc: kidsdescriptions[index] || "Default description",
            context: kidscontext[index] || "Default context",
            btn: 'View Detail',
        };
    });

// Shuffle and then move 1st and 3rd image to last
function prepareWalldata() {
    const allData = generateWalldata();
    const firstImg = allData[85];   // 1st image
    const thirdImg = allData[94];   // 3rd image

    // Remove 1st and 3rd from array before shuffle
    const filtered = allData.filter((_, i) => i !== 0 && i !== 2);

    // Shuffle remaining
    const shuffled = seededShuffle(filtered, 42);

    // Add 1st and 3rd back to the end
    shuffled.push(firstImg, thirdImg);

    return shuffled;
}

// Final export
export const walldata = prepareWalldata();
